import { AreaTeamBase } from './base/area-team-base';

export class AreaTeam extends AreaTeamBase { }